import { EnumService } from "../shared/EnumService";

export class TipoEditalCampoEnumService extends EnumService{

  constructor(){
    super('EnumEditalTipoCampo');
  }
 
}